import { render } from "./FormCrossWord.vue?vue&type=template&id=4cc76bfe&scoped=true"
import script from "./FormCrossWord.vue?vue&type=script&lang=js"
export * from "./FormCrossWord.vue?vue&type=script&lang=js"

import "./FormCrossWord.vue?vue&type=style&index=0&id=4cc76bfe&scoped=true&lang=css"

import exportComponent from "/home/vueltaciclista/app/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc76bfe"]])

export default __exports__